import { useTranslation } from 'react-i18next';
import type { BusinessAgent } from '../../types/agent';

interface AgentCardProps {
  agent: BusinessAgent;
  onRemove: () => void;
}

export function AgentCard({ agent, onRemove }: AgentCardProps) {
  const { t } = useTranslation();

  const formatDate = (dateString: string) => {
    return new Date(dateString).toLocaleDateString('pl-PL', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  const getInitials = () => {
    return `${agent.firstName?.charAt(0) || ''}${agent.lastName?.charAt(0) || ''}`.toUpperCase();
  };

  return (
    <div className="flex items-center justify-between bg-surface-card rounded-lg p-4 hover:bg-surface-card-hover transition-colors">
      <div className="flex items-center gap-3">
        {/* Avatar */}
        {agent.avatarUrl ? (
          <img
            src={agent.avatarUrl}
            alt={`${agent.firstName} ${agent.lastName}`}
            className="w-10 h-10 rounded-full object-cover"
          />
        ) : (
          <div className="w-10 h-10 bg-brand-primary rounded-full flex items-center justify-center text-white font-medium">
            {getInitials()}
          </div>
        )}

        {/* Info */}
        <div>
          <p className="text-ink-primary font-medium">
            {agent.firstName} {agent.lastName}
          </p>
          <p className="text-sm text-ink-secondary">{agent.email}</p>
          <p className="text-xs text-ink-muted">
            {t('agents.joinedAt', { date: formatDate(agent.assignedAt) })}
          </p>
        </div>
      </div>

      {/* Remove Button */}
      <button
        onClick={onRemove}
        className="p-2 text-ink-secondary hover:text-brand-warm-deep hover:bg-surface-card-hover rounded-lg transition-colors"
        title={t('common.remove')}
      >
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
        </svg>
      </button>
    </div>
  );
}
